import { render, staticRenderFns } from "./CarForm.vue?vue&type=template&id=10d86dc4&scoped=true&"
import script from "./CarForm.vue?vue&type=script&lang=js&"
export * from "./CarForm.vue?vue&type=script&lang=js&"
import style0 from "./CarForm.vue?vue&type=style&index=0&id=10d86dc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d86dc4",
  null
  
)

component.options.__file = "CarForm.vue"
export default component.exports